import { Box, Grid, ResponsiveContext, Text, Image, Stack } from "grommet";
import { take } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { Link, useNavigate, useParams } from "react-router-dom";
import ScrollContainer from "../components/ScrollContainer";
import { SeasonViewModel } from "./SeasonsStore";

export const SeasonRow = ({ season, children }: { season: SeasonViewModel; children?: React.ReactElement }) => {
    const size = React.useContext(ResponsiveContext);
    const linkProps = season.id ? { to: `/seasons/${season.id}` } : { to: "" };

    return (
        <Link style={{ textDecoration: "none", color: "unset" }} {...linkProps}>
            <Box background={"background"} pad="small" hoverIndicator="background-back" onClick={() => {}}>
                <Grid columns={size == "small" ? ["80px", "120px", "auto"] : ["130px", "200px", "auto"]} gap="small">
                    <Avatar name={season.name} round={"18px"} size={size == "small" ? "60px" : "128px"} src={season.logoUri}></Avatar>
                    <Box direction="row" align="center" gap="small">
                        <Box>
                            <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                                {season.name}
                            </Text>
                            <Text size="small"> {season.participantCount} participants</Text>
                        </Box>
                    </Box>
                    <Box justify="center">{children && children}</Box>
                    {/* {size !== "small" && (
                        <ScrollContainer direction={"-x"}>
                            <Box direction="row" justify="end" fill gap="medium">
                                {season.participants.map((participant) => (
                                    <Box direction="row" key={participant.id} align="center" gap="small" width={{ min: "70px" }}>
                                        {participant.team && (
                                            <Box align="center">
                                                <Avatar name={participant.team.name} round={"18px"} size="70" src={participant.team.logoUri}></Avatar>
                                                <Text>{participant.team.name}</Text>
                                            </Box>
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        </ScrollContainer>
                    )} */}
                </Grid>
            </Box>
        </Link>
    );
};
